module.exports = __webpack_public_path__ + "img/new-business-hero-static.541c89c7.svg";